import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(
  <Router basename="/players">
    <App />
  </Router>,
  document.getElementById("root")
);
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js